import MDBox from "../../../../../../components/MDBox";
import MDTypography from "../../../../../../components/MDTypography";
import DataTable from "../../../../../../views/Tables/DataTable";
import Card from "@mui/material/Card";
import DefaultItem from "../../../../../../views/Items/DefaultItem";
import WebsiteIcon from "@mui/icons-material/Web";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";

const ParticipantsInCharge = ({memberRow}) => {

    return  <Card>
        <MDBox pt={2} px={2} lineHeight={1}>
            <MDTypography variant="h6" fontWeight="medium">
                Authorized Users
            </MDTypography>
        </MDBox>
        <MDBox p={2}>
            {memberRow && <DataTable
                table={memberRow}
                entriesPerPage={false}
                showTotalEntries={false}
                isSorted={false}
            />}
        </MDBox>
    </Card>
}
export default ParticipantsInCharge;